import * as translations from '@/mocks/faq-translations.json'

export default {
    getFAQTranslations() {
        return translations.data;
    }
}
